import sendCertificationStreamDoc from "./sendCertificationStreamDoc";
import sendDataStreamDoc from "./sendDataStreamDoc";

// event-logger
import logEvent from "event-logger/logEvent";

// utils
import unixTimestampInSeconds from "utils/unixTimestampInSeconds";

// A ---------------------------------------------------------------------- M

const genDocRecord = async (isPublic, userID, keypair, dataBody, databoxID) => {
  const timestamp = unixTimestampInSeconds();

  try {
    if (databoxID) {
      // Certification stream
      const dataCertification = await sendCertificationStreamDoc(keypair, dataBody, timestamp, databoxID);

      if (!dataCertification.txid) {
        // Log certification error
        await logEvent(
          databoxID,
          "event_databox_certification_error",
          timestamp,
          "Certification stream failed for doc record.",
          {
            dataType: "doc",
            errorMessage: "Missing txid in certification stream.",
            certificationStatus: false,
          },
          userID
        );

        console.error("Error in genDocRecord: missing txid");

        return {
          success: false,
          error: "Error in genDocRecord: missing txid",
        };
      }

      // Data stream
      const result = await sendDataStreamDoc(isPublic, userID, dataBody, dataCertification, timestamp, databoxID);

      if (!result.success) {
        await logEvent(
          databoxID,
          "event_databox_certification_error",
          timestamp,
          "Data stream failed for doc record.",
          {
            certificationID: dataCertification.txid,
            dataType: "doc",
            errorMessage: result.error,
            certificationStatus: false,
          },
          userID
        );
      } else {
        await logEvent(
          databoxID,
          "event_databox_certification_success",
          timestamp,
          "Certification successfully performed for doc record.",
          {
            certificationID: dataCertification.txid,
            dataType: "doc",
            certificationStatus: true,
          },
          userID
        );
      }

      console.log(result);
      return result;
    } else {
      // Certification stream
      const dataCertification = await sendCertificationStreamDoc(keypair, dataBody, timestamp);

      if (!dataCertification.txid) {
        console.error("Error in genDocRecord: missing txid");
        return {
          success: false,
          error: "Error in genDocRecord: missing txid",
        };
      }

      // Data stream
      const result = await sendDataStreamDoc(isPublic, userID, dataBody, dataCertification, timestamp);
      console.log(result);
      return result;
    }
  } catch (error) {
    console.error("Error in genDocRecord:", error);

    if (databoxID) {
      await logEvent(
        databoxID,
        "event_databox_certification_error",
        timestamp,
        "An unexpected error occurred during the record certification process.",
        {
          dataType: "doc",
          errorMessage: error.message,
          certificationStatus: false,
        },
        userID
      );
    }

    const result = {
      success: false,
      error: error.message,
    };

    console.log(result);
    return result;
  }
};

export default genDocRecord;
